package boostie.components.style

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.silk.components.style.ComponentStyle
import org.jetbrains.compose.web.css.px

// rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
// rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;

val Modifier.defaultShadow: Modifier
    get() = boxShadow(offsetX = 0.px, offsetY = 10.px, blurRadius = 6.px, spreadRadius = (-6).px, color = Color.rgba(17, 17, 17, 0.1f))

private val shadowColor = Color.rgb(0x60, 0x64, 0x67)

val ShadowStyle by ComponentStyle {
    val shadowColor = Color.rgb(0x60, 0x64, 0x67)

    base {
        Modifier
            .boxShadow(0.px, 1.px, 2.px, 0.px, shadowColor.copyf(alpha = 0.3f))
            .boxShadow(0.px, 1.px, 3.px, 1.px, shadowColor.copyf(alpha = 0.15f))
    }
}
